<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/RQR3a4/tc-custom/9781595587664.jpg?1704272855633" alt="This image is the cover for the book Working"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Working
      </h1>
      <p class="bookDescription body article font2">
        <b>A Pulitzer Prize winner interviews workers, from policemen to piano tuners: “Magnificent . . . To read it is to hear America talking.” —<i>The Boston Globe</i></b><br/>  <br/><i>A National Book Award Finalist and </i>New York Times<i> bestseller</i><br/>  <br/> Studs Terkel’s classic oral history <i>Working</i> is a compelling look at jobs and the people who do them. Consisting of over one hundred interviews with everyone from a gravedigger to a studio head, this book provides a “brilliant” and enduring portrait of people’s feelings about their working lives. This edition includes a new foreword by <i>New York Times</i> journalist Adam Cohen (<i>Forbes</i>).<br/>  <br/> “Splendid . . . Important . . . Rich and fascinating . . . The people we meet are not digits in a poll but real people with real names who share their anecdotes, adventures, and aspirations with us.” —<i>Business Week</i><br/>  <br/> “The talk in <i>Working</i> is good talk—earthy, passionate, honest, sometimes tender, sometimes crisp, juicy as reality, seasoned with experience.” —<i>The Washington Post</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Studs Terkel
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New Press, The
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?530e7392